export const UNAUTHENTICATED_HTTP_CODE = 401;
export const UNAUTHORIZED_HTTP_CODE = 403;
export const SENTRY_IGNORE_HTTP_ERRORS = new Set([401, 403]);
export const TIMEOUT_MS = 30_000; // 30 seconds
